import { render, staticRenderFns } from "./ApproverFree.vue?vue&type=template&id=78bd70a6&scoped=true&"
import script from "./ApproverFree.vue?vue&type=script&lang=js&"
export * from "./ApproverFree.vue?vue&type=script&lang=js&"
import style0 from "./ApproverFree.vue?vue&type=style&index=0&id=78bd70a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd70a6",
  null
  
)

export default component.exports